import { createStore as createUsersStore } from '@md/users/store'
import { createStore as createCartStore } from '@md/cart/store'
import { createStore as createWishlistStore } from '@md/wishlist/store'
import { createStore as createUIStore } from '@md/ui/store'

export function createStore(parameters) {
  return {
    modules: {
      users: createUsersStore(parameters),
      cart: createCartStore(parameters),
      wishlist: createWishlistStore(parameters),
      ui: createUIStore(parameters),
    },
  };
}

export function createStoreObject({ Store, Vue }) {
  return new Store(createStore({ Store, Vue }));
}
